import { render } from "./TokenMetadataAdmin.vue?vue&type=template&id=1d4f967c&scoped=true"
import script from "./TokenMetadataAdmin.vue?vue&type=script&lang=js"
export * from "./TokenMetadataAdmin.vue?vue&type=script&lang=js"

import "./TokenMetadataAdmin.vue?vue&type=style&index=0&id=1d4f967c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4f967c"]])

export default __exports__